<template>
  <el-table :data="tableServerInfo" border>
    <el-table-column prop="ids" :label="$t('app.cardDetail.cardSms.serialNumber')" align="center" width="60px"></el-table-column>
    <el-table-column prop="orderNum" :label="$t('app.cardDetail.cardSms.orderNumber')" align="center" width="220"></el-table-column>
    <el-table-column prop="productName" :label="$t('app.cardDetail.cardSms.packageName')" align="center" width="220"></el-table-column>
    <el-table-column prop="moUse" :label="$t('app.internationalCardInfo.cardSmsProduct.usedMo')" align="center" width="120"></el-table-column>
    <el-table-column prop="moTotal" :label="$t('app.internationalCardInfo.cardSmsProduct.totalMo')" align="center" width="120"></el-table-column>
    <!-- <el-table-column prop="mtUse" label="已使用(MT)" align="center" width="120"></el-table-column>
    <el-table-column prop="mtTotal" label="总条数(MT)" align="center" width="120"></el-table-column> -->
    <el-table-column prop="status" :label="$t('app.cardDetail.cardSms.packageStatus')" align="center" >
      <template slot-scope="scope">
        <span v-if="scope.row.status == '未使用'" >{{ $t('app.cardDetail.cardJftc.status.unused') }}</span>
        <span v-else-if="scope.row.status == '使用中'" >{{ $t('app.cardDetail.cardJftc.status.inUse') }}</span>
        <span v-else-if="scope.row.status == '已使用'" >{{ $t('app.cardDetail.cardJftc.status.used')  }}</span>
        <span v-else-if="scope.row.status == '已过期'" >{{ $t('app.cardDetail.cardJftc.status.expired') }}</span>
        <span v-else-if="scope.row.status == '已转移'" >{{ $t('app.cardDetail.cardJftc.status.transferred')}}</span>
        <span v-else-if="scope.row.status == '已作废'" >{{ $t('app.cardDetail.cardJftc.status.invalid') }}</span>
        <span v-else>{{ scope.row.status }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="startTime" :label="$t('app.cardDetail.cardSms.startTime')" align="center" width="220"></el-table-column>
    <el-table-column prop="endTime" :label="$t('app.cardDetail.cardSms.endTime')" align="center" width="220"></el-table-column>
    <el-table-column label="操作" align="center" width="200" v-if="adminShow">
      <template slot-scope="scope">
        <el-button size="mini" type="danger" v-if='!scope.row.startTime && scope.row.status !== "已转移"' @click="activeOrderSms(scope.row.orderNum)" style="background:#24D2B5;border: 1px solid #24D2B5;width:72px" v-hasPermi="['inter:active:sms']">激活套餐</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { cardSmsProduct } from "@/api/api.js"; //资费列表
import { mannualActiveSms } from "@/api/international.js";
export default {
  props: {
    iccid: {
      type: [String]
    },
    channel: {
      type: [String]
    },

  },
  data() {
    return{
      tableServerInfo:[],
    }
  },
  computed: {
    adminShow () {
      return this.$store.getters.user.userType =='1'
    }
  },
  watch: {
    iccid() {
      this.initData();
    }
  },
  methods: {
    Packagestatus(status) {
      let obj = {
        1: "未使用",
        2: "使用中",
        3: "已使用",
        4: "已过期",
        5: "已转移",
        6: "已作废",
      };
      return obj[status];
    },
    changeIccid(iccid){
      this.iccid = iccid;
    },
    // 获取列表的数据
    initData(){
      if(!this.iccid || this.iccid == ''){
        return;
      }
      let params = {
        iccid : this.iccid
      };
      cardSmsProduct(params).then(res => {
        if(res.data.code == 200){
          this.tableServerInfo = res.data.data;
          this.tableServerInfo.map((item,index)=>{
            item.ids = index + 1;
            //item.status = this.Packagestatus(item.status);
          })
        }
      })
    },
    //手动激活
    activeOrderSms(row){
      this.$confirm('是否继续激活套餐?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          orderNum:row,
          iccid : this.iccid
        }
        mannualActiveSms(params).then(res => {
          if (res.data.code == 200){
            this.initData();
            this.$message({
              type: 'success',
              message: '激活成功!'
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消激活'
        });          
      });
    }
  },
  created() {
   this.initData();
  }
};
</script>

<style scoped lang="less">

</style>


